import { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";

export default function Header() {
  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    let navbar = document.getElementById("navbar");
    let navHeight = navbar.clientHeight;
    let main = document.getElementById("main");
    if (main) main.style.marginTop = `${navHeight}px`;
  }, []);

  function openMenu() {
    const elem = document.getElementById("navbar-sticky");
    if (elem.style.display !== "none" && elem.style.display !== "") {
      elem.style.display = "none";
    } else {
      elem.style.display = "block";
    }
  }

  const getLinkClass = (path) => {
    const isActive = pathname === path;
    return `block font-bold py-2 pl-3 pr-4 md:p-0 transition-colors duration-300 ${
      isActive
        ? "text-accent md:text-accent border-b-2 border-accent"
        : "text-heads hover:text-accent md:hover:text-accent md:border-b-2 md:border-transparent md:hover:border-accent"
    }`;
  };

  return (
    <nav
      id="navbar"
      className="px-2 sm:px-4 py-3 fixed w-full z-50 top-0 left-0 glassmorphism border-b border-white/20 transition-all duration-300"
    >
      <div className="container flex flex-wrap items-center justify-between mx-auto">
        <div className="flex items-center">
          <Link to="/" className="flex items-center gap-3 group">
            <img src="/logo.png" alt="Shri Krishna Sankirtan Logo" className="h-10 w-auto object-contain" />
            <span className="self-center text-2xl font-semibold font-Philosopher whitespace-nowrap text-heads group-hover:text-accent transition-colors duration-300">
              Shri Krishna Sankirtan
            </span>
          </Link>
        </div>
        <div className="flex md:order-2">
          <button
            onClick={openMenu}
            type="button"
            className="inline-flex items-center p-2 text-sm text-heads rounded-lg md:hidden hover:bg-main/20 focus:outline-none focus:ring-2 focus:ring-main/50 transition-colors"
          >
            <span className="sr-only">Open main menu</span>
            <svg
              className="w-6 h-6"
              aria-hidden="true"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                clipRule="evenodd"
              ></path>
            </svg>
          </button>
        </div>
        <div
          className="items-center justify-between hidden w-full md:flex md:w-auto md:order-1"
          id="navbar-sticky"
        >
          <ul className="flex flex-col mt-4 rounded-lg md:flex-row md:space-x-8 md:mt-0 md:text-sm md:font-medium">
            <li>
              <Link to="/" className={getLinkClass('/')}>
                Home
              </Link>
            </li>
            <li>
              <Link to="/about" className={getLinkClass('/about')}>
                About
              </Link>
            </li>
            <li>
              <Link to="/sandesh" className={getLinkClass('/sandesh')}>
                Sandesh
              </Link>
            </li>
            <li>
              <Link to="/seva-prkalp" className={getLinkClass('/seva-prkalp')}>
                Seva Prkalp
              </Link>
            </li>
            <li>
              <Link to="/books" className={getLinkClass('/books')}>
                Books
              </Link>
            </li>
            <li>
              <Link to="/gallery" className={getLinkClass('/gallery')}>
                Gallery
              </Link>
            </li>
            <li>
              <Link to="/contact" className={getLinkClass('/contact')}>
                Contact
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
